import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';

import { checkAddressErrors } from 'utils';

import {
  ShowHideComponentsButtonBox,
  ShowHideComponentsButton,
  ValidationMessage,
  AngleUp,
} from './styles';

const propTypes = {
  namespace: PropTypes.string,
  setAreComponentsRendered: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  countryCodeFieldName: PropTypes.string,
};

const defaultProps = {
  namespace: null,
  isRequired: true,
  countryCodeFieldName: null,
};

const HideComponentsButtonInner = memo(function HideComponentsButtonInner({ hasErrors, setAreComponentsRendered }) {
  return (
    <>
      <ShowHideComponentsButton
        onClick={() => !hasErrors && setAreComponentsRendered(false)}
        $disabled={hasErrors}
      >
        Hide Components
        <AngleUp $disabled={hasErrors} />
      </ShowHideComponentsButton>
      <ValidationMessage visible={hasErrors}>
        Please fill in all required fields before collapsing this section.
      </ValidationMessage>
    </>
  );
});

function HideComponentsButton({ namespace, setAreComponentsRendered, isRequired, countryCodeFieldName }) {
  return (
    <ShowHideComponentsButtonBox width={[1, 1, 1]}>
      <FormSpy subscription={{ errors: true, values: true }}>
        {({ errors, values }) => {
          const hasErrors = checkAddressErrors(namespace, errors, values, isRequired, countryCodeFieldName);

          return (
            <HideComponentsButtonInner
              hasErrors={hasErrors}
              setAreComponentsRendered={setAreComponentsRendered}
            />
          );
        }}
      </FormSpy>
    </ShowHideComponentsButtonBox>
  );
}

HideComponentsButton.propTypes = propTypes;
HideComponentsButton.defaultProps = defaultProps;

export default HideComponentsButton;
